import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@custom-components';
import { strSortFn } from '../helperFunctions';
import FeatureFlagTable from './FeatureFlagTable';
import FeatureFlagContainer from './FeatureFlagContainer';
import List from '../List';

const featureViewFilters = [
  {
    id: 'ALL_FEATURES_VIEW',
    label: 'All Features',
    filterFn: () => true
  },
  {
    id: 'ACTIVE_FEATURES',
    label: 'Activated Features',
    filterFn: (item) => item.active === true
  },
  {
    id: 'DEACTIVED_FEATURES',
    label: 'Dectivated Features',
    filterFn: (item) => item.active === false
  }
];

const featureSortFilters = [
  {
    id: 'NO_FILTER',
    label: 'No Filters'
  },
  {
    id: 'FEATURE_NAME_SORT_DESC',
    label: 'Feature Name (desc)',
    sortFn: (a, b) => strSortFn(a, b, 'featureName')
  },
  {
    id: 'FEATURE_NAME_SORT_ASC',
    label: 'Feature Name (asc)',
    sortFn: (a, b) => strSortFn(a, b, 'featureName', 'desc')
  }
];

function FeatureFlagList(props) {
  const { loading, error, features, updateList } = props;

  return (
    <Grid.ScreenClassRender
      render={(screenClass) => (
        <FeatureFlagContainer>
          {({
            pagination,
            search,
            sortBy,
            toggle,
            view,
            updatePagination,
            updateSearch,
            updateSortBy,
            updateToggle,
            updateView,
            activateFeatureFlag
          }) => (
            <List
              initialPaginationValue={pagination}
              initialQueryValue={search}
              initialSortFilterId={sortBy}
              initialToggleValue={toggle}
              initialViewFilterId={view}
              data={features}
              loading={loading}
              error={error}
              viewFilters={featureViewFilters}
              sortFilters={featureSortFilters}
              screenClass={screenClass}
              tableComponent={FeatureFlagTable}
              mutations={{ activateFeatureFlag, updateList }}
              helpText="Search by feature name or description"
              noDataObj={{
                message: 'There are no features for that search, or no features have been created',
                title: 'No Features'
              }}
              searchBy={['featureName', 'description']}
              listComponentProps={{
                defaultView: 'tableView',
                interactionHooks: {
                  onPaginationChange: (p) => updatePagination(p),
                  onSearchChange: (s) => updateSearch(s),
                  onSortFilterClick: (s) => updateSortBy(s.id),
                  onViewFilterClick: (v) => updateView(v.id),
                  onViewToggleClick: (t) => updateToggle(t)
                }
              }}
            />
          )}
        </FeatureFlagContainer>
      )}
    />
  );
}

FeatureFlagList.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.shape({}),
  updateList: PropTypes.func.isRequired,
  features: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

FeatureFlagList.defaultProps = {
  loading: true,
  error: null
};

export default FeatureFlagList;
